import Vue from "vue";
import store from "../../store";
import get from "lodash/get";

const TikTok = {
  enable() {
    Vue.$log.info("tik tok enable");
    // eslint-disable-next-line no-unused-expressions,wrap-iife
    !(function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      let ttq = (w[t] = w[t] || []);
      ((ttq.methods = [
        "page",
        "track",
        "identify",
        "instances",
        "debug",
        "on",
        "off",
        "once",
        "ready",
        "alias",
        "group",
        "enableCookie",
        "disableCookie"
      ]),
        (ttq.setAndDefer = function (t, e) {
          t[e] = function () {
            t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
          };
        }));
      for (let i = 0; i < ttq.methods.length; i++)
        ttq.setAndDefer(ttq, ttq.methods[i]);
      ((ttq.instance = function (t) {
        const e = ttq._i[t] || [];
        for (let method of ttq.methods) ttq.setAndDefer(e, method);
        return e;
      }),
        (ttq.load = function (e, n) {
          let i = "https://analytics.tiktok.com/i18n/pixel/events.js";
          ((ttq._i = ttq._i || {}),
            (ttq._i[e] = []),
            (ttq._i[e]._u = i),
            (ttq._t = ttq._t || {}),
            (ttq._t[e] = +new Date()),
            (ttq._o = ttq._o || {}),
            (ttq._o[e] = n || {}));
          n = document.createElement("script");
          ((n.type = "text/javascript"),
            (n.async = !0),
            (n.src = i + "?sdkid=" + e + "&lib=" + t));
          e = document.getElementsByTagName("script")[0];
          e.parentNode.insertBefore(n, e);
        }));

      ttq.load("CQH58HRC77U47I0VJHB0");
      ttq.page();
    })(window, document, "ttq");
  },
  wait() {
    return !!window.ttq;
  },
  init() {},
  consulta() {
    window.ttq.track("ViewContent", {
      contents: [
        {
          content_type: "product",
          content_name: "Paso 0 - Datos Personales"
        }
      ]
    });
  },
  oferta() {
    if (!get(store, "state.esCliente", false)) {
      window.ttq.track("Contact", {
        contents: [
          {
            content_type: "product",
            content_name: "Paso 1 - Simulador"
          }
        ]
      });
      return;
    }

    if (get(store, "state.esCliente", false)) {
      window.ttq.track("ViewContent", {
        contents: [
          {
            content_type: "product",
            content_name: "simulador"
          }
        ]
      });
    }
  },
  landingQR() {
    window.ttq.track("ClickButton", {
      contents: [
        {
          content_type: "product",
          content_name: "Paso 2 - Código QR"
        }
      ]
    });
  },
  paso1() {
    window.ttq.track("Search", {
      contents: [
        {
          content_type: "product",
          content_name: "Paso 3 - Datos personales"
        }
      ]
    });
  },
  paso2() {
    window.ttq.track("AddPaymentInfo", {
      contents: [
        {
          content_type: "product",
          content_name: "Paso 4 - Datos laborales"
        }
      ]
    });
  },
  paso3() {
    window.ttq.track("AddToCart", {
      contents: [
        {
          content_type: "product",
          content_name: "Paso 5 - Info Adicional"
        }
      ]
    });
  },
  paso4() {
    window.ttq.track("AddToWishlist", {
      contents: [
        {
          content_type: "product",
          content_name: "Paso 6 - Validación"
        }
      ]
    });
  },
  entrega() {
    window.ttq.track("Download", {
      contents: [
        {
          content_type: "product",
          content_name: "Paso 7 - Entrega tarjeta"
        }
      ]
    });
  },
  resumen() {
    window.ttq.track("InitiateCheckout", {
      contents: [
        {
          content_type: "product",
          content_name: "Paso 8 - Resumen"
        }
      ]
    });
  },
  contratos() {
    window.ttq.track("PlaceAnOrder", {
      contents: [
        {
          content_type: "product",
          content_name: "Paso 9 - Contratos"
        }
      ]
    });
  },
  gracias() {
    window.ttq.track("CompleteRegistration", {
      contents: [
        {
          content_type: "product",
          content_name: "Paso 10 - Thank you page PP OM"
        }
      ]
    });
  }
};

export default TikTok;
